// /help-centre: the public Help centre (W4-5; D-19 spelling), inside the
// site frame (routes/_site.tsx). The same articles and search as the
// in-app /help; /help-centre#<slug> opens one article.
import { createFileRoute } from '@tanstack/react-router';
import { HelpCentrePage } from '@/features/site/help-centre/HelpCentrePage';

export const Route = createFileRoute('/_site/help-centre')({
  component: HelpCentrePage,
});
